
import React from 'react';
import { Button } from '../../../components/base/Button';

export const AboutSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Welcome to Eco Loft Insulation Installers: Your Trusted Coventry Insulation Specialists
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                At Eco Loft Insulation Installers, we put you and your energy efficiency needs at the heart of our service. As a Coventry-based, family-owned business, we are deeply rooted in our community and are proud to provide premier loft insulation services to the West Midlands area. Our unique blend of traditional craftsmanship and modern insulation technology ensures your home improvement aligns with your comfort goals and budget, all accomplished efficiently and professionally.
              </p>
              <p>
                We understand how significant your home is to you and strive to enhance its energy efficiency by transforming your existing loft space. Trust in Eco Loft Insulation Installers to create a more comfortable, energy-efficient home you'll love for years to come.
              </p>
            </div>
            <Button 
              variant="outline" 
              className="mt-8"
              href="/about"
            >
              Discover Our Story
            </Button>
          </div>
          
          <div className="relative">
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20insulation%20installer%20working%20in%20a%20modern%20loft%20space%20with%20high-quality%20insulation%20materials%2C%20showing%20before%20and%20after%20transformation%20of%20attic%20space%20with%20proper%20insulation%20installation%2C%20clean%20professional%20work%20environment%2C%20natural%20lighting&width=600&height=400&seq=about-img&orientation=landscape"
              alt="About Eco Loft Insulation Installers"
              className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
